import { render, staticRenderFns } from "./PopularRoutesItem.vue?vue&type=template&id=ff42a0c0&scoped=true&"
import script from "./PopularRoutesItem.vue?vue&type=script&lang=js&"
export * from "./PopularRoutesItem.vue?vue&type=script&lang=js&"
import style0 from "./PopularRoutesItem.vue?vue&type=style&index=0&id=ff42a0c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff42a0c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff42a0c0')) {
      api.createRecord('ff42a0c0', component.options)
    } else {
      api.reload('ff42a0c0', component.options)
    }
    module.hot.accept("./PopularRoutesItem.vue?vue&type=template&id=ff42a0c0&scoped=true&", function () {
      api.rerender('ff42a0c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/PopularRoutesItem.vue"
export default component.exports